import React, { SetStateAction } from "react";
import TextField from "../inputs/TextField";
import HexInput from "../../ui/HexInput";

interface IProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setAdvancedSearchState: React.Dispatch<SetStateAction<any>>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  advancedSearchState: any;
  advancedSearchConfig: Array<{
    name: string;
    label: string;
    tooltipText: string;
    type?: string;
    items?: [];
  }>;
}

const AdvancedSearchForm = ({
  advancedSearchState,
  advancedSearchConfig,
  setAdvancedSearchState,
}: IProps) => {
  return (
    <div className="form-items">
      {advancedSearchConfig.map((config) => {
        if (config.type && config.type === "HEX") {
          return (
            <div className="form-control">
              <HexInput
                min={0}
                max={1048575}
                label={config.label}
                value={
                  advancedSearchState[config.name] ||
                  // eslint-disable-next-line eqeqeq
                  advancedSearchState[config.name] == "0"
                    ? +advancedSearchState[config.name]
                    : undefined
                }
                onChange={(value) => {
                  setAdvancedSearchState({
                    ...advancedSearchState,
                    [config.name]: `${value}`,
                  });
                }}
                tooltipText={config.tooltipText}
              />
            </div>
          );
        }
        return (
          <div className="form-control">
            <TextField
              labelText={config.label}
              value={advancedSearchState[config.name]}
              onChange={(value) => {
                setAdvancedSearchState({
                  ...advancedSearchState,
                  [config.name]: value,
                });
              }}
              tooltipText={config.tooltipText}
            />
          </div>
        );
      })}
    </div>
  );
};

export default AdvancedSearchForm;
